import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sid = match ? match[1] : null;
    (async () => {
      if (!sid) {
        navigate("/");
        return;
      }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: data } });
      } catch (e) {
        navigate("/");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-50 gap-3" data-testid="auth-callback">
      <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
      <p className="text-sm text-zinc-500">Signing you in…</p>
    </div>
  );
}
